import { observer } from 'mobx-react-lite'
import { lazy } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { ArrowLeftOutlined } from '@ant-design/icons'

import { useStore } from 'store/useStore'
import { ContainerLK } from 'sections/LKSection/shared/components/ContainerLK/ContainerLK'
import { Margin, Padding } from 'components/ui'
import { Button, Flex, Title } from 'components/uiKit'
import { getPvzItemRoute } from 'utils/helpers/routes/getRoutes'
import { useAsyncEffect } from 'utils/hooks/useAsyncEffect'

import { PvzKeys } from '../../data'
import { PvzEditAreaForm } from './PvzEditAreaForm/PvzEditAreaForm'

const getKey = (key: string) => `${PvzKeys.editAreaPage}.${key}`

const PvzEditAreaPage = observer(() => {
  const { viewPvzUiStore: uiStore } = useStore()

  const { pvzId } = useParams()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const pvz = uiStore.selectedPvz

  useAsyncEffect(async () => {
    if (pvzId) {
      void uiStore.switchPvz(+pvzId)

      if (uiStore.pvzList.length === 0) {
        await uiStore.getPvzList()
      }

      uiStore.setSelectedPvz(pvz ?? uiStore.getPvz(+pvzId))
    }
  }, [pvzId])

  const backButtonHandler = () => {
    if (pvzId) {
      navigate(getPvzItemRoute(+pvzId))
    }
  }

  return (
    <ContainerLK>
      <Padding py={32} style={{ width: '100%' }}>
        <Margin mb={32}>
          <Flex gap={16} align="center">
            <Button shape="circle" icon={<ArrowLeftOutlined />} onClick={backButtonHandler} />

            <Title>{t(getKey('Редактирование площади'))}</Title>
          </Flex>
        </Margin>

        <Flex vertical style={{ maxWidth: 600 }}>
          <PvzEditAreaForm />
        </Flex>
      </Padding>
    </ContainerLK>
  )
})

export default PvzEditAreaPage

export const PvzEditAreaPageAsync = lazy(() => import('./PvzEditAreaPage'))
